import type { AssetDetail } from "@/entities/asset";

import { useGetAssetMarkers } from "@/entities/asset";
import { useGetLocation } from "@/entities/location";
import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";
import { useOrganizationContext } from "@/modules/organization/organization-context";

import { getAssetPageMarkers } from "./asset-page-map.helper";

export const useAssetPageMap = (asset?: AssetDetail) => {
  const mapId = `asset_page_${asset?.id}`;
  const { contextSlug } = useOrganizationContext();

  const { getReferentialAttr } = useReferentialConditionRatings();
  const assetColor = getReferentialAttr(
    { rating: asset?.condition_rating ?? undefined },
    "color"
  );
  const { markers: components = [], isLoading: isAssetMarkersLoading } =
    useGetAssetMarkers(asset?.id);
  const { location, isLoading: isLocationLoading } = useGetLocation(
    asset?.location_id
  );

  const markers = getAssetPageMarkers({
    context: contextSlug ?? null,
    location,
    asset,
    assetColor,
    components,
  });

  return {
    mapId,
    markers,
    loading: isLocationLoading || isAssetMarkersLoading,
  };
};
